import { render, staticRenderFns } from "./selectCourse.vue?vue&type=template&id=4a97bc54&scoped=true&"
import script from "./selectCourse.vue?vue&type=script&lang=js&"
export * from "./selectCourse.vue?vue&type=script&lang=js&"
import style0 from "./selectCourse.vue?vue&type=style&index=0&id=4a97bc54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97bc54",
  null
  
)

export default component.exports